// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import './MessageSpinner.css';

// const seedMessages = [
//   { id: 1, type: 'text', text: "Happy Birthday! You're the best! 🎉", author: 'John, NY', time: '2 hours ago' },
//   { id: 2, type: 'text', text: 'Wishing you a year of amazing success and joy!', author: 'Sarah, London', time: '4 hours ago' },
//   { id: 3, type: 'video', text: 'A special toast to you!', mediaUrl: 'https://www.w3schools.com/html/mov_bbb.mp4', author: 'Mike, Lagos', time: '6 hours ago' },
//   { id: 4, type: 'text', text: 'Hope your day is as wonderful as you are!', author: 'Elena, Tokyo', time: '8 hours ago' },
//   { id: 5, type: 'audio', text: 'A little birthday song for you…', mediaUrl: 'https://www.w3schools.com/html/horse.ogg', author: 'David, Sydney', time: '12 hours ago' },
//   { id: 6, type: 'text', text: 'Your wisdom and grace inspire us all. Happy birthday!', author: 'Maria, Dubai', time: '1 day ago' },
// ];

// const SPARKLE_GLYPHS = ['✦', '✧', '⋆'];

// /* ── Icons ── */
// const Icon = {
//   Crest: (p) => (
//     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
//       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
//       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
//     </svg>
//   ),
//   ArrowLeft: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ),
//   Chevron: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" {...p}>
//       <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ),
//   Video: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <polygon points="23 7 16 12 23 17 23 7" />
//       <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
//     </svg>
//   ),
//   Mic: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
//       <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
//       <line x1="12" y1="19" x2="12" y2="23" />
//       <line x1="8" y1="23" x2="16" y2="23" />
//     </svg>
//   ),
//   Text: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <line x1="21" y1="15" x2="15" y2="15" />
//       <line x1="21" y1="9" x2="15" y2="9" />
//       <line x1="10" y1="3" x2="8" y2="21" />
//       <line x1="16" y1="3" x2="14" y2="21" />
//     </svg>
//   ),
//   Search: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <circle cx="11" cy="11" r="7" />
//       <line x1="21" y1="21" x2="16.65" y2="16.65" />
//     </svg>
//   ),
//   Close: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <line x1="18" y1="6" x2="6" y2="18" />
//       <line x1="6" y1="6" x2="18" y2="18" />
//     </svg>
//   ),
//   Shuffle: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <polyline points="16 3 21 3 21 8" />
//       <line x1="4" y1="20" x2="21" y2="3" />
//       <polyline points="21 16 21 21 16 21" />
//       <line x1="15" y1="15" x2="21" y2="21" />
//       <line x1="4" y1="4" x2="9" y2="9" />
//     </svg>
//   ),
//   Camera: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
//       <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
//       <circle cx="12" cy="13" r="4" />
//     </svg>
//   ),
// };

// const TYPE_ICON = { text: Icon.Text, audio: Icon.Mic, video: Icon.Video };
// const firstName = (author = '') => author.split(',')[0].trim() || 'A guest';

// function SealBurst({ burstKey }) {
//   const particles = useMemo(() => {
//     if (!burstKey) return [];
//     return Array.from({ length: 14 }).map((_, i) => {
//       const angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
//       const dist = 30 + Math.random() * 26;
//       return {
//         id: i,
//         x: Math.cos(angle) * dist,
//         y: Math.sin(angle) * dist,
//         size: 3 + Math.random() * 4,
//       };
//     });
//   }, [burstKey]);

//   if (!burstKey) return null;

//   return (
//     <span className="seal-burst" aria-hidden="true">
//       {particles.map((p) => (
//         <motion.span
//           key={`${burstKey}-${p.id}`}
//           className="seal-burst-dot"
//           style={{ width: p.size, height: p.size }}
//           initial={{ x: 0, y: 0, opacity: 1, scale: 0.4 }}
//           animate={{ x: p.x, y: p.y, opacity: 0, scale: 1 }}
//           transition={{ duration: 0.7, ease: 'easeOut' }}
//         />
//       ))}
//     </span>
//   );
// }

// export default function MessageSpinner() {
//   const [messages, setMessages] = useState(seedMessages);
//   const [activeId, setActiveId] = useState(seedMessages[0]?.id ?? null);
//   const [flipped, setFlipped] = useState(false);
//   const [search, setSearch] = useState('');

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [uploadType, setUploadType] = useState('text');
//   const [newAuthor, setNewAuthor] = useState('');
//   const [newMessageText, setNewMessageText] = useState('');
//   const [mediaFile, setMediaFile] = useState(null);
//   const [isStamping, setIsStamping] = useState(false);
//   const [burstKey, setBurstKey] = useState(0);

//   // Live Audio Recording States
//   const [isRecordingAudio, setIsRecordingAudio] = useState(false);
//   const [audioBlobUrl, setAudioBlobUrl] = useState(null);
//   const audioRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);

//   // Live Video Recording States
//   const [isRecordingVideo, setIsRecordingVideo] = useState(false);
//   const [videoBlobUrl, setVideoBlobUrl] = useState(null);
//   const videoRecorderRef = useRef(null);
//   const videoChunksRef = useRef([]);
//   const liveVideoPreviewRef = useRef(null);

//   const fileInputRef = useRef(null);
//   const firstFieldRef = useRef(null);
//   const addSealBtnRef = useRef(null);

//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return messages;
//     return messages.filter((m) => m.author.toLowerCase().includes(q));
//   }, [messages, search]);

//   const activeIndex = filtered.findIndex((m) => m.id === activeId);
//   const active = activeIndex >= 0 ? filtered[activeIndex] : null;

//   useEffect(() => {
//     if (filtered.length === 0) {
//       setActiveId(null);
//       return;
//     }
//     if (!filtered.some((m) => m.id === activeId)) {
//       setActiveId(filtered[0].id);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [filtered]);

//   // Reset flip state cleanly on selection change so cards don't jitter
//   useEffect(() => {
//     setFlipped(false);
//   }, [activeId]);

//   const goTo = useCallback(
//     (delta) => {
//       if (filtered.length < 2) return;
//       const idx = filtered.findIndex((m) => m.id === activeId);
//       const base = idx === -1 ? 0 : idx;
//       const next = (base + delta + filtered.length) % filtered.length;
//       setActiveId(filtered[next].id);
//     },
//     [filtered, activeId]
//   );

//   const shuffle = useCallback(() => {
//     if (filtered.length < 2) return;
//     let idx;
//     do {
//       idx = Math.floor(Math.random() * filtered.length);
//     } while (filtered[idx].id === activeId);
//     setActiveId(filtered[idx].id);
//   }, [filtered, activeId]);

//   const openModal = () => {
//     setIsModalOpen(true);
//     setUploadType('text');
//     setNewAuthor('');
//     setNewMessageText('');
//     setMediaFile(null);
//     setAudioBlobUrl(null);
//     setVideoBlobUrl(null);
//   };

//   const closeModal = useCallback(() => {
//     setIsModalOpen(false);
//     addSealBtnRef.current?.focus();
//   }, []);

//   /* ── LIVE AUDIO RECORDING ── */
//   const startAudioRecording = async () => {
//     audioChunksRef.current = [];
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       audioRecorderRef.current = new MediaRecorder(stream);
//       audioRecorderRef.current.ondataavailable = (e) => {
//         if (e.data.size > 0) audioChunksRef.current.push(e.data);
//       };
//       audioRecorderRef.current.onstop = () => {
//         const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//         setAudioBlobUrl(URL.createObjectURL(blob));
//         setMediaFile(new File([blob], "voice-message.webm", { type: 'audio/webm' }));
//       };
//       audioRecorderRef.current.start();
//       setIsRecordingAudio(true);
//     } catch {
//       alert("Microphone access was denied or is not supported.");
//     }
//   };

//   const stopAudioRecording = () => {
//     if (audioRecorderRef.current && isRecordingAudio) {
//       audioRecorderRef.current.stop();
//       audioRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
//       setIsRecordingAudio(false);
//     }
//   };

//   /* ── LIVE VIDEO RECORDING ── */
//   const startVideoRecording = async () => {
//     videoChunksRef.current = [];
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
//       if (liveVideoPreviewRef.current) {
//         liveVideoPreviewRef.current.srcObject = stream;
//       }
//       videoRecorderRef.current = new MediaRecorder(stream);
//       videoRecorderRef.current.ondataavailable = (e) => {
//         if (e.data.size > 0) videoChunksRef.current.push(e.data);
//       };
//       videoRecorderRef.current.onstop = () => {
//         const blob = new Blob(videoChunksRef.current, { type: 'video/webm' });
//         setVideoBlobUrl(URL.createObjectURL(blob));
//         setMediaFile(new File([blob], "video-message.webm", { type: 'video/webm' }));
//       };
//       videoRecorderRef.current.start();
//       setIsRecordingVideo(true);
//     } catch {
//       alert("Camera and microphone access was denied or is not supported.");
//     }
//   };

//   const stopVideoRecording = () => {
//     if (videoRecorderRef.current && isRecordingVideo) {
//       videoRecorderRef.current.stop();
//       videoRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
//       setIsRecordingVideo(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       setMediaFile(file);
//       if (uploadType === 'audio') setAudioBlobUrl(URL.createObjectURL(file));
//       if (uploadType === 'video') setVideoBlobUrl(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!newAuthor.trim()) return;
//     if (uploadType === 'text' && !newMessageText.trim()) return;
//     if (uploadType !== 'text' && !mediaFile) {
//       alert(`Please record or choose a ${uploadType} file first.`);
//       return;
//     }

//     setIsStamping(true);
//     setBurstKey((k) => k + 1);

//     const newMsg = {
//       id: Date.now(),
//       type: uploadType,
//       text: uploadType === 'text' ? newMessageText.trim() : `A special ${uploadType} message from ${firstName(newAuthor)}`,
//       mediaUrl: mediaFile ? URL.createObjectURL(mediaFile) : null,
//       author: newAuthor.trim(),
//       time: 'Just now',
//     };

//     setTimeout(() => {
//       setMessages((prev) => [newMsg, ...prev]);
//       setSearch('');
//       setActiveId(newMsg.id);
//       setIsStamping(false);
//       setIsModalOpen(false);
//       addSealBtnRef.current?.focus();
//     }, 650);
//   };

//   const messageWord = messages.length === 1 ? 'message' : 'messages';

//   return (
//     <div className="messages-page">
//       <Link to="/" className="back-nav-btn">
//         <Icon.ArrowLeft width="20" height="20" /> Return
//       </Link>

//       <div className="messages-bg" aria-hidden="true">
//         <div className="floating-sparkles">
//           {[...Array(10)].map((_, i) => (
//             <span
//               key={i}
//               className="drift-sparkle"
//               style={{
//                 left: `${Math.random() * 100}%`,
//                 animationDelay: `${Math.random() * 8}s`,
//                 animationDuration: `${9 + Math.random() * 8}s`,
//                 fontSize: `${8 + Math.random() * 10}px`,
//               }}
//             >
//               {SPARKLE_GLYPHS[Math.floor(Math.random() * SPARKLE_GLYPHS.length)]}
//             </span>
//           ))}
//         </div>
//       </div>

//       <div className="messages-container">
//         <motion.div
//           className="messages-header"
//           initial={{ opacity: 0, y: -16 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.7 }}
//         >
//           <Icon.Crest className="header-crest" />
//           <span className="page-kicker">Grace In Motion</span>
//           <h1>Leave a Message</h1>
//           <p>{messages.length} {messageWord} shared so far — break one open, or leave your own.</p>
//         </motion.div>

//         {/* ── SPOTLIGHT CARD WITH STABLE LAYOUT ── */}
//         <section className="spotlight-region">
//           <button
//             type="button"
//             className="spotlight-nav"
//             onClick={() => goTo(-1)}
//             disabled={filtered.length < 2}
//             aria-label="Previous message"
//           >
//             <Icon.Chevron className="icon-flip" width="20" height="20" />
//           </button>

//           <div className="seal-stage">
//             <AnimatePresence mode="wait">
//               {active ? (
//                 <motion.div
//                   key={active.id}
//                   className="seal-plaque"
//                   initial={{ opacity: 0, y: 14 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -14 }}
//                   transition={{ duration: 0.35 }}
//                 >
//                   <div className="seal-emblem">
//                     <span className="seal-emblem-ring">
//                       <Icon.Crest width="26" height="26" />
//                     </span>
//                   </div>
//                   <span className="seal-ribbon seal-ribbon--left" aria-hidden="true" />
//                   <span className="seal-ribbon seal-ribbon--right" aria-hidden="true" />

//                   <div className="seal-viewport">
//                     <div className={`seal-flip-inner ${flipped ? 'is-open' : ''}`}>
//                       <div className="seal-face seal-face--front">
//                         <span className="seal-eyebrow">A message from</span>
//                         <span className="seal-sender">{firstName(active.author)}</span>
//                         <button
//                           type="button"
//                           className="break-seal-btn"
//                           onClick={() => setFlipped(true)}
//                         >
//                           Open message
//                         </button>
//                       </div>

//                       <div className="seal-face seal-face--back" aria-live="polite">
//                         <button
//                           type="button"
//                           className="reseal-btn"
//                           onClick={() => setFlipped(false)}
//                           aria-label="Close this message"
//                         >
//                           <Icon.Close width="14" height="14" />
//                         </button>

//                         {active.type === 'video' && (
//                           <video className="seal-media" controls src={active.mediaUrl} />
//                         )}
//                         {active.type === 'audio' && (
//                           <audio className="seal-media seal-media--audio" controls src={active.mediaUrl} />
//                         )}
//                         <p className={`seal-text ${active.type !== 'text' ? 'is-caption' : ''}`}>
//                           “{active.text}”
//                         </p>
//                         <div className="seal-meta">
//                           <span className="seal-author">{active.author}</span>
//                           <span className="seal-time">{active.time}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ) : (
//                 <motion.div key="empty" className="seal-empty" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//                   <p>No messages match “{search}” yet.</p>
//                   <button type="button" className="btn-outline" onClick={() => setSearch('')}>Clear search</button>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </div>

//           <button
//             type="button"
//             className="spotlight-nav"
//             onClick={() => goTo(1)}
//             disabled={filtered.length < 2}
//             aria-label="Next message"
//           >
//             <Icon.Chevron width="20" height="20" />
//           </button>
//         </section>

//         <div className="spotlight-footer">
//           <button type="button" className="shuffle-btn" onClick={shuffle} disabled={filtered.length < 2}>
//             <Icon.Shuffle width="15" height="15" /> Shuffle
//           </button>
//           {active && (
//             <span className="spotlight-position">
//               Message {activeIndex + 1} of {filtered.length}
//             </span>
//           )}
//         </div>

//         {/* ── THE WALL ── */}
//         <div className="wall-toolbar">
//           <label className="search-field">
//             <Icon.Search width="16" height="16" />
//             <input
//               type="text"
//               placeholder="Find a name…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               aria-label="Search messages by name"
//             />
//             {search && (
//               <button type="button" className="search-clear" onClick={() => setSearch('')} aria-label="Clear search">
//                 <Icon.Close width="12" height="12" />
//               </button>
//             )}
//           </label>

//           <button type="button" ref={addSealBtnRef} className="btn-gold add-seal-btn" onClick={openModal}>
//             + Leave a message
//           </button>
//         </div>

//         <div className="wishing-wall" role="list" aria-label="All messages">
//           {filtered.map((m) => {
//             const TypeGlyph = TYPE_ICON[m.type] || Icon.Text;
//             return (
//               <button
//                 key={m.id}
//                 type="button"
//                 role="listitem"
//                 className={`seal-chip ${m.id === activeId ? 'is-active' : ''}`}
//                 onClick={() => setActiveId(m.id)}
//                 title={m.author}
//               >
//                 <span className="chip-ring">
//                   <TypeGlyph width="14" height="14" />
//                 </span>
//                 <span className="chip-name">{firstName(m.author)}</span>
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* ── ENGRAVING MODAL ── */}
//       <AnimatePresence>
//         {isModalOpen && (
//           <motion.div
//             className="modal-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onMouseDown={(e) => { if (e.target === e.currentTarget) closeModal(); }}
//           >
//             <motion.div
//               className="engrave-modal"
//               role="dialog"
//               aria-modal="true"
//               initial={{ opacity: 0, y: 24, scale: 0.97 }}
//               animate={{ opacity: 1, y: 0, scale: 1 }}
//               exit={{ opacity: 0, y: 16, scale: 0.97 }}
//               transition={{ duration: 0.25 }}
//             >
//               <button type="button" className="modal-close" onClick={closeModal} aria-label="Close">
//                 <Icon.Close width="18" height="18" />
//               </button>

//               <h2>Leave a message</h2>

//               <form className="engrave-form" onSubmit={handleSubmit}>
//                 <div className="segmented-control">
//                   <button type="button" className={`segment ${uploadType === 'text' ? 'active' : ''}`} onClick={() => setUploadType('text')}>
//                     <Icon.Text width="16" height="16" /> Text
//                   </button>
//                   <button type="button" className={`segment ${uploadType === 'audio' ? 'active' : ''}`} onClick={() => setUploadType('audio')}>
//                     <Icon.Mic width="16" height="16" /> Audio
//                   </button>
//                   <button type="button" className={`segment ${uploadType === 'video' ? 'active' : ''}`} onClick={() => setUploadType('video')}>
//                     <Icon.Video width="16" height="16" /> Video
//                   </button>
//                 </div>

//                 {uploadType === 'text' && (
//                   <div className="input-group">
//                     <label htmlFor="message-text">Your message</label>
//                     <textarea
//                       id="message-text"
//                       ref={firstFieldRef}
//                       value={newMessageText}
//                       onChange={(e) => setNewMessageText(e.target.value)}
//                       placeholder="Write your message here…"
//                     />
//                   </div>
//                 )}

//                 {uploadType === 'audio' && (
//                   <div className="input-group">
//                     <label>Voice Recording</label>
//                     <div className="recording-container">
//                       {!isRecordingAudio && !audioBlobUrl && (
//                         <button type="button" className="record-action-btn start-rec" onClick={startAudioRecording}>
//                           <Icon.Mic width="18" height="18" /> Record Live Audio
//                         </button>
//                       )}
//                       {isRecordingAudio && (
//                         <button type="button" className="record-action-btn stop-rec pulse-recording" onClick={stopAudioRecording}>
//                           ■ Stop Recording... (Live)
//                         </button>
//                       )}
//                       {audioBlobUrl && !isRecordingAudio && (
//                         <div className="recorded-playback-box">
//                           <audio controls src={audioBlobUrl} style={{ width: '100%' }} />
//                           <button type="button" className="re-record-btn" onClick={() => { setAudioBlobUrl(null); setMediaFile(null); }}>
//                             Record Again
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 {uploadType === 'video' && (
//                   <div className="input-group">
//                     <label>Video Recording / Upload</label>
//                     <div className="recording-container">
//                       {!isRecordingVideo && !videoBlobUrl && (
//                         <div className="video-options-grid">
//                           <button type="button" className="record-action-btn start-rec" onClick={startVideoRecording}>
//                             <Icon.Camera width="18" height="18" /> Record Live Video
//                           </button>
//                           <div className="file-drop-area" onClick={() => fileInputRef.current?.click()} style={{ padding: '16px' }}>
//                             <input type="file" ref={fileInputRef} accept="video/*" onChange={handleFileChange} style={{ display: 'none' }} />
//                             <span>Or choose video file</span>
//                           </div>
//                         </div>
//                       )}
//                       {isRecordingVideo && (
//                         <div className="live-camera-wrapper">
//                           <video ref={liveVideoPreviewRef} autoPlay muted playsInline className="live-camera-feed" />
//                           <button type="button" className="record-action-btn stop-rec pulse-recording" onClick={stopVideoRecording}>
//                             ■ Stop Video Recording
//                           </button>
//                         </div>
//                       )}
//                       {videoBlobUrl && !isRecordingVideo && (
//                         <div className="recorded-playback-box">
//                           <video controls src={videoBlobUrl} className="seal-media" style={{ width: '100%', maxHeight: '180px' }} />
//                           <button type="button" className="re-record-btn" onClick={() => { setVideoBlobUrl(null); setMediaFile(null); }}>
//                             Record Video Again
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 <div className="input-group">
//                   <label htmlFor="message-author">Your name &amp; location</label>
//                   <input
//                     id="message-author"
//                     ref={uploadType === 'text' ? null : firstFieldRef}
//                     type="text"
//                     value={newAuthor}
//                     onChange={(e) => setNewAuthor(e.target.value)}
//                     placeholder="e.g. Jane, Lagos"
//                     required
//                   />
//                 </div>

//                 <div className="stamp-row">
//                   <motion.button
//                     type="submit"
//                     className="btn-gold stamp-btn"
//                     disabled={isStamping}
//                     whileHover={{ scale: isStamping ? 1 : 1.02 }}
//                     whileTap={{ scale: isStamping ? 1 : 0.96 }}
//                   >
//                     {isStamping ? 'Posting…' : 'Post message'}
//                     <SealBurst burstKey={isStamping ? burstKey : 0} />
//                   </motion.button>
//                 </div>
//               </form>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }




import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import './MessageSpinner.css';

const API_URL =
  process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';

const MAX_MEDIA_SECONDS = 120;
const MAX_FILE_BYTES = 100 * 1024 * 1024;

const SPARKLE_GLYPHS = ['✦', '✧', '⋆'];

const Icon = {
  Crest: (p) => (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
      <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
      <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
    </svg>
  ),
  ArrowLeft: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Chevron: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" {...p}>
      <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Video: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" />
    </svg>
  ),
  Mic: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
  ),
  Text: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <line x1="21" y1="15" x2="15" y2="15" />
      <line x1="21" y1="9" x2="15" y2="9" />
      <line x1="10" y1="3" x2="8" y2="21" />
      <line x1="16" y1="3" x2="14" y2="21" />
    </svg>
  ),
  Search: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Close: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Shuffle: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <polyline points="16 3 21 3 21 8" />
      <line x1="4" y1="20" x2="21" y2="3" />
      <polyline points="21 16 21 21 16 21" />
      <line x1="15" y1="15" x2="21" y2="21" />
      <line x1="4" y1="4" x2="9" y2="9" />
    </svg>
  ),
  Camera: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  ),
};

const TYPE_ICON = {
  text: Icon.Text,
  audio: Icon.Mic,
  video: Icon.Video,
};

const firstName = (author = '') =>
  author.split(',')[0].trim() || 'A guest';

const formatClock = (seconds = 0) => {
  const clamped = Math.max(0, Math.min(seconds, MAX_MEDIA_SECONDS));
  const mins = Math.floor(clamped / 60);
  const secs = clamped % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

const timeAgo = (date) => {
  if (!date) return '';

  const seconds = Math.max(
    0,
    Math.floor((Date.now() - new Date(date).getTime()) / 1000)
  );

  if (seconds < 60) return 'Just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

const readMediaDuration = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const element = document.createElement(
      file.type.startsWith('video/') ? 'video' : 'audio'
    );

    element.preload = 'metadata';

    element.onloadedmetadata = () => {
      const duration = element.duration;
      URL.revokeObjectURL(url);

      if (!Number.isFinite(duration)) {
        reject(new Error('Could not read the media duration.'));
        return;
      }

      resolve(duration);
    };

    element.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not read this media file.'));
    };

    element.src = url;
  });

const preferredMimeType = (kind) => {
  const candidates =
    kind === 'video'
      ? [
          'video/webm;codecs=vp9,opus',
          'video/webm;codecs=vp8,opus',
          'video/webm',
          'video/mp4',
        ]
      : [
          'audio/webm;codecs=opus',
          'audio/webm',
          'audio/mp4',
        ];

  return candidates.find((type) => MediaRecorder.isTypeSupported(type)) || '';
};

function SealBurst({ burstKey }) {
  const particles = useMemo(() => {
    if (!burstKey) return [];

    return Array.from({ length: 14 }).map((_, i) => {
      const angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
      const dist = 30 + Math.random() * 26;

      return {
        id: i,
        x: Math.cos(angle) * dist,
        y: Math.sin(angle) * dist,
        size: 3 + Math.random() * 4,
      };
    });
  }, [burstKey]);

  if (!burstKey) return null;

  return (
    <span className="seal-burst" aria-hidden="true">
      {particles.map((p) => (
        <motion.span
          key={`${burstKey}-${p.id}`}
          className="seal-burst-dot"
          style={{ width: p.size, height: p.size }}
          initial={{ x: 0, y: 0, opacity: 1, scale: 0.4 }}
          animate={{ x: p.x, y: p.y, opacity: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        />
      ))}
    </span>
  );
}

export default function MessageSpinner() {
  const [messages, setMessages] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [flipped, setFlipped] = useState(false);
  const [search, setSearch] = useState('');

  const [pageLoading, setPageLoading] = useState(true);
  const [pageError, setPageError] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState('text');
  const [newAuthor, setNewAuthor] = useState('');
  const [newMessageText, setNewMessageText] = useState('');
  const [mediaFile, setMediaFile] = useState(null);
  const [mediaDuration, setMediaDuration] = useState(null);
  const [submitError, setSubmitError] = useState('');
  const [isStamping, setIsStamping] = useState(false);
  const [burstKey, setBurstKey] = useState(0);

  const [isRecordingAudio, setIsRecordingAudio] = useState(false);
  const [audioBlobUrl, setAudioBlobUrl] = useState(null);
  const [audioSeconds, setAudioSeconds] = useState(0);

  const [isRecordingVideo, setIsRecordingVideo] = useState(false);
  const [videoBlobUrl, setVideoBlobUrl] = useState(null);
  const [videoSeconds, setVideoSeconds] = useState(0);

  const audioRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const videoRecorderRef = useRef(null);
  const videoChunksRef = useRef([]);
  const liveVideoPreviewRef = useRef(null);

  const audioIntervalRef = useRef(null);
  const videoIntervalRef = useRef(null);
  const audioStopTimeoutRef = useRef(null);
  const videoStopTimeoutRef = useRef(null);

  const fileInputRef = useRef(null);
  const firstFieldRef = useRef(null);
  const addSealBtnRef = useRef(null);

  const sparkles = useMemo(
    () =>
      [...Array(10)].map((_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 8}s`,
        duration: `${9 + Math.random() * 8}s`,
        fontSize: `${8 + Math.random() * 10}px`,
        glyph:
          SPARKLE_GLYPHS[
            Math.floor(Math.random() * SPARKLE_GLYPHS.length)
          ],
      })),
    []
  );

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();

    if (!q) return messages;

    return messages.filter((m) => {
      const author = String(m.author || '').toLowerCase();
      const text = String(m.text || '').toLowerCase();
      return author.includes(q) || text.includes(q);
    });
  }, [messages, search]);

  const activeIndex = filtered.findIndex((m) => m._id === activeId);
  const active = activeIndex >= 0 ? filtered[activeIndex] : null;

  const stopTimer = (intervalRef, timeoutRef) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const stopStream = (recorder) => {
    recorder?.stream?.getTracks()?.forEach((track) => track.stop());
  };

  const resetMedia = useCallback(() => {
    if (audioBlobUrl) URL.revokeObjectURL(audioBlobUrl);
    if (videoBlobUrl) URL.revokeObjectURL(videoBlobUrl);

    setMediaFile(null);
    setMediaDuration(null);
    setAudioBlobUrl(null);
    setVideoBlobUrl(null);
    setAudioSeconds(0);
    setVideoSeconds(0);
    setSubmitError('');
  }, [audioBlobUrl, videoBlobUrl]);

  const loadMessages = useCallback(async () => {
    try {
      setPageLoading(true);
      setPageError('');

      const response = await fetch(
        `${API_URL}/api/birthday/messages`
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(
          result.message || 'Unable to load birthday messages.'
        );
      }

      const items = Array.isArray(result.data) ? result.data : [];

      setMessages(items);
      setActiveId((current) => current || items[0]?._id || null);
    } catch (error) {
      setPageError(
        error.message || 'Unable to load birthday messages.'
      );
    } finally {
      setPageLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  useEffect(() => {
    if (filtered.length === 0) {
      setActiveId(null);
      return;
    }

    if (!filtered.some((m) => m._id === activeId)) {
      setActiveId(filtered[0]._id);
    }
  }, [filtered, activeId]);

  useEffect(() => {
    setFlipped(false);
  }, [activeId]);

  useEffect(() => {
    return () => {
      stopTimer(audioIntervalRef, audioStopTimeoutRef);
      stopTimer(videoIntervalRef, videoStopTimeoutRef);

      stopStream(audioRecorderRef.current);
      stopStream(videoRecorderRef.current);

      if (audioBlobUrl) URL.revokeObjectURL(audioBlobUrl);
      if (videoBlobUrl) URL.revokeObjectURL(videoBlobUrl);
    };
  }, [audioBlobUrl, videoBlobUrl]);

  const goTo = useCallback(
    (delta) => {
      if (filtered.length < 2) return;

      const idx = filtered.findIndex((m) => m._id === activeId);
      const base = idx === -1 ? 0 : idx;
      const next = (base + delta + filtered.length) % filtered.length;

      setActiveId(filtered[next]._id);
    },
    [filtered, activeId]
  );

  const shuffle = useCallback(() => {
    if (filtered.length < 2) return;

    let idx;

    do {
      idx = Math.floor(Math.random() * filtered.length);
    } while (filtered[idx]._id === activeId);

    setActiveId(filtered[idx]._id);
  }, [filtered, activeId]);

  const openModal = () => {
    setIsModalOpen(true);
    setUploadType('text');
    setNewAuthor('');
    setNewMessageText('');
    resetMedia();
  };

  const closeModal = useCallback(() => {
    if (isRecordingAudio || isRecordingVideo) return;

    setIsModalOpen(false);
    resetMedia();
    addSealBtnRef.current?.focus();
  }, [isRecordingAudio, isRecordingVideo, resetMedia]);

  const stopAudioRecording = useCallback(() => {
    const recorder = audioRecorderRef.current;

    if (recorder?.state === 'recording') {
      recorder.stop();
      stopStream(recorder);
    }

    stopTimer(audioIntervalRef, audioStopTimeoutRef);
    setIsRecordingAudio(false);
  }, []);

  const startAudioRecording = async () => {
    try {
      resetMedia();
      setSubmitError('');

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      const mimeType = preferredMimeType('audio');

      const recorder = mimeType
        ? new MediaRecorder(stream, { mimeType })
        : new MediaRecorder(stream);

      audioChunksRef.current = [];
      audioRecorderRef.current = recorder;

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      recorder.onstop = async () => {
        const type = recorder.mimeType || 'audio/webm';
        const blob = new Blob(audioChunksRef.current, { type });
        const extension = type.includes('mp4') ? 'mp4' : 'webm';
        const file = new File(
          [blob],
          `voice-message.${extension}`,
          { type }
        );

        const previewUrl = URL.createObjectURL(blob);

        setAudioBlobUrl(previewUrl);
        setMediaFile(file);

        try {
          const duration = await readMediaDuration(file);
          setMediaDuration(duration);
        } catch {
          setMediaDuration(audioSeconds || null);
        }
      };

      recorder.start(500);
      setIsRecordingAudio(true);
      setAudioSeconds(0);

      audioIntervalRef.current = setInterval(() => {
        setAudioSeconds((seconds) =>
          Math.min(seconds + 1, MAX_MEDIA_SECONDS)
        );
      }, 1000);

      audioStopTimeoutRef.current = setTimeout(() => {
        stopAudioRecording();
      }, MAX_MEDIA_SECONDS * 1000);
    } catch (error) {
      setSubmitError(
        'Microphone access was denied or is not supported by this browser.'
      );
    }
  };

  const stopVideoRecording = useCallback(() => {
    const recorder = videoRecorderRef.current;

    if (recorder?.state === 'recording') {
      recorder.stop();
      stopStream(recorder);
    }

    if (liveVideoPreviewRef.current) {
      liveVideoPreviewRef.current.srcObject = null;
    }

    stopTimer(videoIntervalRef, videoStopTimeoutRef);
    setIsRecordingVideo(false);
  }, []);

  const startVideoRecording = async () => {
    try {
      resetMedia();
      setSubmitError('');

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'user',
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
        audio: true,
      });

      if (liveVideoPreviewRef.current) {
        liveVideoPreviewRef.current.srcObject = stream;
      }

      const mimeType = preferredMimeType('video');

      const recorder = mimeType
        ? new MediaRecorder(stream, {
            mimeType,
            videoBitsPerSecond: 2_500_000,
          })
        : new MediaRecorder(stream);

      videoChunksRef.current = [];
      videoRecorderRef.current = recorder;

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          videoChunksRef.current.push(event.data);
        }
      };

      recorder.onstop = async () => {
        const type = recorder.mimeType || 'video/webm';
        const blob = new Blob(videoChunksRef.current, { type });
        const extension = type.includes('mp4') ? 'mp4' : 'webm';
        const file = new File(
          [blob],
          `video-message.${extension}`,
          { type }
        );

        const previewUrl = URL.createObjectURL(blob);

        setVideoBlobUrl(previewUrl);
        setMediaFile(file);

        try {
          const duration = await readMediaDuration(file);
          setMediaDuration(duration);
        } catch {
          setMediaDuration(videoSeconds || null);
        }
      };

      recorder.start(500);
      setIsRecordingVideo(true);
      setVideoSeconds(0);

      videoIntervalRef.current = setInterval(() => {
        setVideoSeconds((seconds) =>
          Math.min(seconds + 1, MAX_MEDIA_SECONDS)
        );
      }, 1000);

      videoStopTimeoutRef.current = setTimeout(() => {
        stopVideoRecording();
      }, MAX_MEDIA_SECONDS * 1000);
    } catch (error) {
      setSubmitError(
        'Camera and microphone access was denied or is not supported by this browser.'
      );
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    setSubmitError('');

    try {
      if (!file.type.startsWith(`${uploadType}/`)) {
        throw new Error(
          `Please choose a valid ${uploadType} file.`
        );
      }

      if (file.size > MAX_FILE_BYTES) {
        throw new Error(
          'This file is too large. Please choose a file under 100 MB.'
        );
      }

      const duration = await readMediaDuration(file);

      if (duration > MAX_MEDIA_SECONDS + 0.25) {
        throw new Error(
          'Audio and video messages cannot be longer than 2 minutes.'
        );
      }

      resetMedia();
      setMediaFile(file);
      setMediaDuration(duration);

      const previewUrl = URL.createObjectURL(file);

      if (uploadType === 'audio') {
        setAudioBlobUrl(previewUrl);
      } else {
        setVideoBlobUrl(previewUrl);
      }
    } catch (error) {
      event.target.value = '';
      setSubmitError(error.message);
    }
  };

  const changeUploadType = (type) => {
    if (isRecordingAudio || isRecordingVideo) return;

    setUploadType(type);
    resetMedia();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!newAuthor.trim()) {
      setSubmitError('Please enter your name and location.');
      return;
    }

    if (uploadType === 'text' && !newMessageText.trim()) {
      setSubmitError('Please write your birthday message.');
      return;
    }

    if (uploadType !== 'text' && !mediaFile) {
      setSubmitError(
        `Please record or choose a ${uploadType} message first.`
      );
      return;
    }

    if (
      uploadType !== 'text' &&
      mediaDuration &&
      mediaDuration > MAX_MEDIA_SECONDS + 0.25
    ) {
      setSubmitError(
        'Audio and video messages cannot be longer than 2 minutes.'
      );
      return;
    }

    try {
      setIsStamping(true);
      setSubmitError('');
      setBurstKey((key) => key + 1);

      const formData = new FormData();

      // Append fields BEFORE media. This also helps multipart middleware.
      formData.append('type', uploadType);
      formData.append('author', newAuthor.trim());
      formData.append('text', newMessageText.trim());

      if (mediaFile) {
        formData.append('media', mediaFile);
      }

      const response = await fetch(
        `${API_URL}/api/birthday/messages`,
        {
          method: 'POST',
          body: formData,
        }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(
          result.message || 'Unable to post your message.'
        );
      }

      const created = result.data;

      setMessages((current) => [created, ...current]);
      setSearch('');
      setActiveId(created._id);
      setFlipped(false);

      setTimeout(() => {
        setIsModalOpen(false);
        setNewAuthor('');
        setNewMessageText('');
        resetMedia();
        setIsStamping(false);
        addSealBtnRef.current?.focus();
      }, 450);
    } catch (error) {
      setIsStamping(false);
      setSubmitError(
        error.message || 'Unable to post your message.'
      );
    }
  };

  const messageWord = messages.length === 1 ? 'message' : 'messages';

  return (
    <div className="messages-page">
      <Link to="/" className="back-nav-btn">
        <Icon.ArrowLeft width="20" height="20" /> Return
      </Link>

      <div className="messages-bg" aria-hidden="true">
        <div className="floating-sparkles">
          {sparkles.map((sparkle) => (
            <span
              key={sparkle.id}
              className="drift-sparkle"
              style={{
                left: sparkle.left,
                animationDelay: sparkle.delay,
                animationDuration: sparkle.duration,
                fontSize: sparkle.fontSize,
              }}
            >
              {sparkle.glyph}
            </span>
          ))}
        </div>
      </div>

      <div className="messages-container">
        <motion.div
          className="messages-header"
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <Icon.Crest className="header-crest" />
          <span className="page-kicker">Grace In Motion</span>
          <h1>Leave a Message</h1>
          <p>
            {messages.length} {messageWord} shared so far — break one
            open, or leave your own.
          </p>
        </motion.div>

        {pageLoading && (
          <div className="message-page-status">
            Loading birthday messages…
          </div>
        )}

        {pageError && (
          <div className="message-page-status is-error">
            {pageError}
            {' '}
            <button
              type="button"
              className="shuffle-btn"
              onClick={loadMessages}
            >
              Try again
            </button>
          </div>
        )}

        {!pageLoading && (
          <>
            <section className="spotlight-region">
              <button
                type="button"
                className="spotlight-nav"
                onClick={() => goTo(-1)}
                disabled={filtered.length < 2}
                aria-label="Previous message"
              >
                <Icon.Chevron className="icon-flip" width="20" height="20" />
              </button>

              <div className="seal-stage">
                <AnimatePresence mode="wait">
                  {active ? (
                    <motion.div
                      key={active._id}
                      className="seal-plaque"
                      initial={{ opacity: 0, y: 14 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -14 }}
                      transition={{ duration: 0.35 }}
                    >
                      <div className="seal-emblem">
                        <span className="seal-emblem-ring">
                          <Icon.Crest width="26" height="26" />
                        </span>
                      </div>

                      <span
                        className="seal-ribbon seal-ribbon--left"
                        aria-hidden="true"
                      />
                      <span
                        className="seal-ribbon seal-ribbon--right"
                        aria-hidden="true"
                      />

                      <div className="seal-viewport">
                        <div
                          className={`seal-flip-inner ${
                            flipped ? 'is-open' : ''
                          }`}
                        >
                          <div className="seal-face seal-face--front">
                            <span className="seal-eyebrow">
                              A message from
                            </span>

                            <span className="seal-sender">
                              {firstName(active.author)}
                            </span>

                            <button
                              type="button"
                              className="break-seal-btn"
                              onClick={() => setFlipped(true)}
                            >
                              Open message
                            </button>
                          </div>

                          <div
                            className="seal-face seal-face--back"
                            aria-live="polite"
                          >
                            <button
                              type="button"
                              className="reseal-btn"
                              onClick={() => setFlipped(false)}
                              aria-label="Close this message"
                            >
                              <Icon.Close width="14" height="14" />
                            </button>

                            {active.type === 'video' && (
                              <video
                                className="seal-media"
                                controls
                                preload="metadata"
                                playsInline
                                src={active.mediaUrl}
                              />
                            )}

                            {active.type === 'audio' && (
                              <audio
                                className="seal-media seal-media--audio"
                                controls
                                preload="metadata"
                                src={active.mediaUrl}
                              />
                            )}

                            <p
                              className={`seal-text ${
                                active.type !== 'text'
                                  ? 'is-caption'
                                  : ''
                              }`}
                            >
                              “{active.text}”
                            </p>

                            <div className="seal-meta">
                              <span className="seal-author">
                                {active.author}
                              </span>

                              <span className="seal-time">
                                {timeAgo(active.createdAt)}
                                {active.mediaDurationSeconds
                                  ? ` · ${formatClock(
                                      Math.round(
                                        active.mediaDurationSeconds
                                      )
                                    )}`
                                  : ''}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  ) : (
                    <motion.div
                      key="empty"
                      className="seal-empty"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                    >
                      <p>
                        {search
                          ? `No messages match “${search}” yet.`
                          : 'No birthday messages have been posted yet.'}
                      </p>

                      {search && (
                        <button
                          type="button"
                          className="btn-outline"
                          onClick={() => setSearch('')}
                        >
                          Clear search
                        </button>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              <button
                type="button"
                className="spotlight-nav"
                onClick={() => goTo(1)}
                disabled={filtered.length < 2}
                aria-label="Next message"
              >
                <Icon.Chevron width="20" height="20" />
              </button>
            </section>

            <div className="spotlight-footer">
              <button
                type="button"
                className="shuffle-btn"
                onClick={shuffle}
                disabled={filtered.length < 2}
              >
                <Icon.Shuffle width="15" height="15" /> Shuffle
              </button>

              {active && (
                <span className="spotlight-position">
                  Message {activeIndex + 1} of {filtered.length}
                </span>
              )}
            </div>

            <div className="wall-toolbar">
              <label className="search-field">
                <Icon.Search width="16" height="16" />

                <input
                  type="text"
                  placeholder="Find a name or message…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  aria-label="Search messages"
                />

                {search && (
                  <button
                    type="button"
                    className="search-clear"
                    onClick={() => setSearch('')}
                    aria-label="Clear search"
                  >
                    <Icon.Close width="12" height="12" />
                  </button>
                )}
              </label>

              <button
                type="button"
                ref={addSealBtnRef}
                className="btn-gold add-seal-btn"
                onClick={openModal}
              >
                + Leave a message
              </button>
            </div>

            <div
              className="wishing-wall"
              role="list"
              aria-label="All messages"
            >
              {filtered.length > 0 ? (
                filtered.map((message) => {
                  const TypeGlyph =
                    TYPE_ICON[message.type] || Icon.Text;

                  return (
                    <button
                      key={message._id}
                      type="button"
                      role="listitem"
                      className={`seal-chip ${
                        message._id === activeId ? 'is-active' : ''
                      }`}
                      onClick={() => setActiveId(message._id)}
                      title={message.author}
                    >
                      <span className="chip-ring">
                        <TypeGlyph width="14" height="14" />
                      </span>

                      <span className="chip-name">
                        {firstName(message.author)}
                      </span>
                    </button>
                  );
                })
              ) : (
                <div className="message-empty-wall">
                  Be the first to leave a birthday message.
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onMouseDown={(e) => {
              if (e.target === e.currentTarget) closeModal();
            }}
          >
            <motion.div
              className="engrave-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="leave-message-title"
              initial={{ opacity: 0, y: 24, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 16, scale: 0.97 }}
              transition={{ duration: 0.25 }}
            >
              <button
                type="button"
                className="modal-close"
                onClick={closeModal}
                disabled={isRecordingAudio || isRecordingVideo}
                aria-label="Close"
              >
                <Icon.Close width="18" height="18" />
              </button>

              <h2 id="leave-message-title">Leave a message</h2>

              <form
                className="engrave-form"
                onSubmit={handleSubmit}
              >
                <div className="segmented-control">
                  {[
                    ['text', Icon.Text, 'Text'],
                    ['audio', Icon.Mic, 'Audio'],
                    ['video', Icon.Video, 'Video'],
                  ].map(([type, Glyph, label]) => (
                    <button
                      key={type}
                      type="button"
                      className={`segment ${
                        uploadType === type ? 'active' : ''
                      }`}
                      onClick={() => changeUploadType(type)}
                      disabled={isRecordingAudio || isRecordingVideo}
                    >
                      <Glyph width="16" height="16" />
                      {label}
                    </button>
                  ))}
                </div>

                {submitError && (
                  <div className="message-submit-error" role="alert">
                    {submitError}
                  </div>
                )}

                {uploadType === 'text' && (
                  <div className="input-group">
                    <label htmlFor="message-text">
                      Your message
                    </label>

                    <textarea
                      id="message-text"
                      ref={firstFieldRef}
                      value={newMessageText}
                      onChange={(e) =>
                        setNewMessageText(e.target.value)
                      }
                      maxLength={2000}
                      placeholder="Write your message here…"
                      required
                    />

                    <span className="recording-limit-note">
                      {newMessageText.length}/2000 characters
                    </span>
                  </div>
                )}

                {uploadType === 'audio' && (
                  <div className="input-group">
                    <label>Voice Message</label>

                    <div className="recording-container">
                      {!isRecordingAudio && !audioBlobUrl && (
                        <>
                          <button
                            type="button"
                            className="record-action-btn start-rec"
                            onClick={startAudioRecording}
                          >
                            <Icon.Mic width="18" height="18" />
                            Record Live Audio
                          </button>

                          <div
                            className="file-drop-area"
                            onClick={() =>
                              fileInputRef.current?.click()
                            }
                            style={{ padding: '16px' }}
                          >
                            <input
                              type="file"
                              ref={fileInputRef}
                              accept="audio/*"
                              onChange={handleFileChange}
                              style={{ display: 'none' }}
                            />

                            <span>Or choose an audio file</span>
                          </div>
                        </>
                      )}

                      {isRecordingAudio && (
                        <button
                          type="button"
                          className="record-action-btn stop-rec pulse-recording"
                          onClick={stopAudioRecording}
                        >
                          ■ Stop Recording
                          <span className="recording-timer">
                            {formatClock(audioSeconds)} / 02:00
                          </span>
                        </button>
                      )}

                      {audioBlobUrl && !isRecordingAudio && (
                        <div className="recorded-playback-box">
                          <audio
                            controls
                            src={audioBlobUrl}
                            style={{ width: '100%' }}
                          />

                          {mediaDuration && (
                            <span className="media-duration">
                              Duration:{' '}
                              {formatClock(
                                Math.round(mediaDuration)
                              )}
                            </span>
                          )}

                          <button
                            type="button"
                            className="re-record-btn"
                            onClick={resetMedia}
                          >
                            Record / Choose Again
                          </button>
                        </div>
                      )}

                      <p className="recording-limit-note">
                        Maximum audio length: 2 minutes.
                      </p>
                    </div>
                  </div>
                )}

                {uploadType === 'video' && (
                  <div className="input-group">
                    <label>Video Message</label>

                    <div className="recording-container">
                      {!isRecordingVideo && !videoBlobUrl && (
                        <div className="video-options-grid">
                          <button
                            type="button"
                            className="record-action-btn start-rec"
                            onClick={startVideoRecording}
                          >
                            <Icon.Camera width="18" height="18" />
                            Record Live Video
                          </button>

                          <div
                            className="file-drop-area"
                            onClick={() =>
                              fileInputRef.current?.click()
                            }
                            style={{ padding: '16px' }}
                          >
                            <input
                              type="file"
                              ref={fileInputRef}
                              accept="video/*"
                              onChange={handleFileChange}
                              style={{ display: 'none' }}
                            />

                            <span>Or choose a video file</span>
                          </div>
                        </div>
                      )}

                      {isRecordingVideo && (
                        <div className="live-camera-wrapper">
                          <video
                            ref={liveVideoPreviewRef}
                            autoPlay
                            muted
                            playsInline
                            className="live-camera-feed"
                          />

                          <button
                            type="button"
                            className="record-action-btn stop-rec pulse-recording"
                            onClick={stopVideoRecording}
                          >
                            ■ Stop Video
                            <span className="recording-timer">
                              {formatClock(videoSeconds)} / 02:00
                            </span>
                          </button>
                        </div>
                      )}

                      {videoBlobUrl && !isRecordingVideo && (
                        <div className="recorded-playback-box">
                          <video
                            controls
                            playsInline
                            src={videoBlobUrl}
                            className="seal-media"
                            style={{
                              width: '100%',
                              maxHeight: '220px',
                            }}
                          />

                          {mediaDuration && (
                            <span className="media-duration">
                              Duration:{' '}
                              {formatClock(
                                Math.round(mediaDuration)
                              )}
                            </span>
                          )}

                          <button
                            type="button"
                            className="re-record-btn"
                            onClick={resetMedia}
                          >
                            Record / Choose Again
                          </button>
                        </div>
                      )}

                      <p className="recording-limit-note">
                        Maximum video length: 2 minutes.
                      </p>
                    </div>
                  </div>
                )}

                {uploadType !== 'text' && (
                  <div className="input-group">
                    <label htmlFor="media-caption">
                      Short caption (optional)
                    </label>

                    <input
                      id="media-caption"
                      type="text"
                      value={newMessageText}
                      maxLength={240}
                      onChange={(e) =>
                        setNewMessageText(e.target.value)
                      }
                      placeholder="e.g. A special birthday toast…"
                    />
                  </div>
                )}

                <div className="input-group">
                  <label htmlFor="message-author">
                    Your name &amp; location
                  </label>

                  <input
                    id="message-author"
                    ref={
                      uploadType === 'text'
                        ? null
                        : firstFieldRef
                    }
                    type="text"
                    value={newAuthor}
                    maxLength={120}
                    onChange={(e) =>
                      setNewAuthor(e.target.value)
                    }
                    placeholder="e.g. Jane, Lagos"
                    required
                  />
                </div>

                <div className="stamp-row">
                  <motion.button
                    type="submit"
                    className="btn-gold stamp-btn"
                    disabled={
                      isStamping ||
                      isRecordingAudio ||
                      isRecordingVideo
                    }
                    whileHover={{
                      scale: isStamping ? 1 : 1.02,
                    }}
                    whileTap={{
                      scale: isStamping ? 1 : 0.96,
                    }}
                  >
                    {isStamping ? 'Posting…' : 'Post message'}

                    <SealBurst
                      burstKey={isStamping ? burstKey : 0}
                    />
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
